import type { App } from 'vue'

// 需要全局引入一些组件，如ElScrollbar，不然一些下拉项样式有问题
import { ElLoading, ElScrollbar, ElMessage } from 'element-plus'

const plugins = [ElLoading]

const components = [ElScrollbar]

// 设置 ElMessage 全局默认 duration（单位：毫秒）
// 默认值为 2000，可以根据需要调整
const DEFAULT_DURATION = 2000

// 包装 ElMessage 方法，设置默认 duration
const wrapMessageMethod = (
  method: (options: string | { message?: string; duration?: number; [key: string]: any }) => any
) => {
  return (options: string | { message?: string; duration?: number; [key: string]: any }) => {
    if (typeof options === 'string') {
      return method({ message: options, duration: DEFAULT_DURATION })
    }
    return method({
      ...options,
      duration: options.duration ?? DEFAULT_DURATION
    })
  }
}

// 重写 ElMessage 的各个方法，设置全局默认 duration
const originalSuccess = ElMessage.success.bind(ElMessage)
const originalWarning = ElMessage.warning.bind(ElMessage)
const originalInfo = ElMessage.info.bind(ElMessage)
const originalError = ElMessage.error.bind(ElMessage)

ElMessage.success = wrapMessageMethod(originalSuccess) as typeof ElMessage.success
ElMessage.warning = wrapMessageMethod(originalWarning) as typeof ElMessage.warning
ElMessage.info = wrapMessageMethod(originalInfo) as typeof ElMessage.info
ElMessage.error = wrapMessageMethod(originalError) as typeof ElMessage.error

export const setupElementPlus = (app: App<Element>) => {
  plugins.forEach((plugin) => {
    app.use(plugin)
  })

  // 为了开发环境启动更快，一次性引入所有样式
  if (import.meta.env.VITE_USE_ALL_ELEMENT_PLUS_STYLE === 'true') {
    import('element-plus/dist/index.css')
    return
  }

  components.forEach((component) => {
    app.component(component.name!, component)
  })
}
